import React, { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

function Button(
  props: { rel: string } & DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
) {
  return <button {...props} />;
}

export default Button;
